import { GET_WORKERS, GET_INSPECTORS } from '../actions/types'
import { usersRef } from '../../config/firebase'

export const getWorkers = () => dispatch => {
  const _users = []
  usersRef
    .where(`municipalityId`, `==`, `LC`)
    .where(`roleId`, `==`, 1)
    .get()
    .then(users => {
      users.docs.map(user => _users.push(user.data()))
      dispatch({
        type: GET_WORKERS,
        workers: _users,
      })
    })
}

export const getInspectors = () => dispatch => {
  const _users = []
  usersRef
    .where(`municipalityId`, `==`, `LC`)
    .where(`roleId`, `==`, 2)
    .get()
    .then(users => {
      users.docs.map(user => _users.push(user.data()))
      dispatch({
        type: GET_INSPECTORS,
        inspectors: _users,
      })
    })
}
